<template>
  <ValidationObserver v-slot="{ handleSubmit }" ref="validationObserver">
    <form @submit.prevent="handleSubmit(submit)" ref="form">
      <div :class="inList ? 'page-container py-0' : 'page-container bg-white '">
        <!-- <img :src="data.profile_photo_url" alt="" /> -->
        <FormGenerator :Fields="Fields" :model="data" :options="options" />
        <div class="text-right">
          <b-spinner
            v-if="loading"
            variant="primary"
            label="Spinning"
          ></b-spinner>
          <b-button v-else variant="primary" type="warning" native-type="submit"
            >Submit</b-button
          >
        </div>
      </div>
    </form>
  </ValidationObserver>
</template>

<script>
import FormGenerator from "@/components/FormGenerator/FormGenerator.vue";
import { Fields, models, options } from "./user_form_fields";
import { getCurrentUser, updateUser } from "@/API/UsersAPIs";
export default {
  components: { FormGenerator },
  props: ["id", "model"],
  name: "UserSettings",
  data() {
    return {
      user: {
        profile_image: ""
      },
      loading: false,
      data: JSON.parse(JSON.stringify(models)),
      options: options,
      Fields: Fields,
      emptyModel: null,
      inList: false
    };
  },
  computed: {},

  watch: {},
  async mounted() {
    this.emptyModel = JSON.stringify(models);
    this.getData();
  },
  methods: {
    previewImage: function(event) {
      const input = event.target;
      if (input.files && input.files[0]) {
        const reader = new FileReader();

        reader.onload = e => {
          this.user.profile_image = e.target.result;
        };

        reader.readAsDataURL(input.files[0]);
      }
    },
    async getData() {
      this.data = { ...JSON.parse(this.emptyModel) };
      let CurrentUser = await getCurrentUser();
      if (CurrentUser) {
        this.data = { ...this.data, ...CurrentUser };
      }
    },
    modelToSubmitDataConverter() {
      var data = [];
      for (const [key, value] of Object.entries(this.data)) {
        if (value !== null && value !== "") {
          data.push({ key: key, data: value });
        }
      }
      return data;
    },
    async submit() {
      this.loading = true;
      let submitData = this.modelToSubmitDataConverter();
      let filteredData = submitData.reduce((acc, item) => {
        if (
          [
            "id",
            "name",
            "email",
            "phone",
            "media",
            "email_verified_at",
            "password",
            "password_confirmation"
          ].includes(item.key)
        ) {
          if (item.key === "email_verified_at") {
            acc[item.key] =
              typeof item.data === "string"
                ? item.data
                : Boolean(Number(item.data));
          } else {
            acc[item.key] = item.data;
          }
        }
        return acc;
      }, {});
      await updateUser(filteredData);
      this.loading = false;
    }
  }
};
</script>

<style scoped></style>
